<template>
  <section class="hero">
    <div class="content">
      <swiper
        loop
        navigation
        :modules="modules"
        :slides-per-view="1"
        :slides-per-group="1"
        :space-between="0"
        :pagination="pagination"
        :autoplay="{
          delay: 2500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }"
        @autoplayTimeLeft="onAutoplayTimeLeft"
        @slideChange="onSlideChange"
      >
        <swiper-slide v-for="(item, i) in data" :key="`Hero-swiper__slide${i}`">
          <img v-if="isMobile && item.mobileImage" :src="item.mobileImage" />
          <img v-else-if="!isMobile && item.image" :src="item.image" />
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination"></div>
    </div>
  </section>
</template>

<script>
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { ref } from "vue";
export default {
  name: "HeroSection",
  components: {
    Swiper,
    SwiperSlide,
  },

  data() {
    return {
      isMobile: false,
    };
  },

  methods: {
    onSlideChange(swiper) {
      const barElement = swiper.el.querySelector(
        `.progress[name="progress${this.activeIndex}"]`
      );
      if (barElement) {
        barElement.style.width = 0;
      }
      this.activeIndex = swiper.realIndex;
    },
    handleResize() {
      if (window.innerWidth < 744) {
        this.isMobile = true;
        this.data = this.dataInfo.filter((item) => item.mobileImage);
      } else {
        this.isMobile = false;
        this.data = this.dataInfo.filter((item) => item.image);
      }
    },
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },

  setup() {
    const activeIndex = ref(0);
    const data = ref([]);
    const dataInfo = ref([
      {
        image: "/images/hero/1.webp",
        mobileImage: "/images/hero/1-mobile.webp",
        progress: 0,
      },
      {
        image: "/images/hero/2.webp",
        mobileImage: "/images/hero/2-mobile.webp",
        progress: 0,
      },
      {
        image: "/images/hero/3.webp",
        mobileImage: "/images/hero/3-mobile.webp",
        progress: 0,
      },
      {
        image: "/images/hero/4.webp",
        mobileImage: "/images/hero/4-mobile.webp",
        progress: 0,
      },
      {
        image: "/images/hero/5.webp",
        mobileImage: "/images/hero/5-mobile.webp",
        progress: 0,
      },
      {
        image: "/images/hero/6.webp",
        mobileImage: "/images/hero/6-mobile.webp",
        progress: 0,
      },
      {
        image: "/images/hero/7.webp",
        mobileImage: "/images/hero/7-mobile.webp",
        progress: 0,
      },
      {
        image: "/images/hero/8.webp",
        mobileImage: "/images/hero/8-mobile.webp",
        progress: 0,
      },
      {
        image: "/images/hero/9.webp",
        mobileImage: "/images/hero/9-mobile.webp",
        progress: 0,
      },
      {
        mobileImage: "/images/hero/10-mobile.webp",
        progress: 0,
      },
      {
        mobileImage: "/images/hero/11-mobile.webp",
        progress: 0,
      },
      {
        mobileImage: "/images/hero/12-mobile.webp",
        progress: 0,
      },
      {
        mobileImage: "/images/hero/13-mobile.webp",
        progress: 0,
      },
      {
        mobileImage: "/images/hero/14-mobile.webp",
        progress: 0,
      },
      {
        mobileImage: "/images/hero/15-mobile.webp",
        progress: 0,
      },
      {
        mobileImage: "/images/hero/16-mobile.webp",
        progress: 0,
      },
    ]);
    const onAutoplayTimeLeft = (s, time, progress) => {
      const barElement = s.el.querySelector(
        `.progress[name="progress${activeIndex.value}"]`
      );
      data.value[activeIndex.value].progress = Math.round((1 - progress) * 100);
      if (barElement) {
        const widthPercent = Math.round((1 - progress) * 100);
        if (widthPercent < 99) {
          barElement.style.width = `${widthPercent}%`;
        } else {
          barElement.style.width = 0;
        }
      }
    };
    return {
      pagination: {
        clickable: true,
        renderBullet: function (index) {
          return `
            <span class="swiper-pagination-bullet">
              <div class="progress" name="progress${index}" style="width: 0%;"></div>
            </span>
          `;
        },
      },
      activeIndex,
      data,
      dataInfo,
      onAutoplayTimeLeft,
      modules: [Autoplay, Navigation, Pagination],
    };
  },
};
</script>

<style scoped lang="sass">
@import "../styles/variables.sass"

.hero
  width: 100%
  position: relative

.swiper-slide
  display: flex
  justify-content: center
  overflow: hidden

  img
    width: 100%
    object-fit: cover
    height: 100dvh

    @media screen and (min-width: $tablet)
      height: 640px

    // Figma 1200 / 1440 / 1920 — hero 800
    @media screen and (min-width: $desktop_xs)
      height: 800px

.hero-swiper-pagination
  position: absolute
  bottom: 0
  z-index: 99
  display: flex
  flex-wrap: wrap
  justify-content: center
  gap: 8px
</style>

<style lang="sass">
@import "../styles/variables.sass"

.hero
  .swiper-pagination
    position: absolute!important
    bottom: 0
    z-index: 10
    display: flex
    flex-wrap: wrap
    justify-content: center
    gap: 4px
    padding-bottom: 24px

    @media screen and (min-width: $tablet)
      gap: 8px
      padding-bottom: 28px

    @media screen and (min-width: $desktop_xs)
      gap: 16px
      padding-bottom: 33px

    &-bullet
      background: #FFFFFF80!important
      width: 24px
      height: 5px
      border-radius: 40px
      margin: 0!important
      position: relative
      opacity: 100%!important

      @media screen and (min-width: $tablet)
        width: 48px

      // Figma 1200 / 1440 — 90px
      @media screen and (min-width: $desktop_xs)
        width: 90px!important
        margin: 0 8px

      @media screen and (min-width: $desktop)
        width: 110px!important

      &:hover
        opacity: 70%!important
        background: #FFFFFFFF!important

      &-active
        background: #FFFFFF80!important
        opacity: 100%!important

    .progress
      width: 0
      height: 5px
      background: #FFFFFFFF
      border-radius: 40px
      position: absolute
      left: 0
      top: 0
      z-index: 10

  .swiper-button-prev, .swiper-button-next
    top: 45%!important
</style>
